import React, { useEffect, useRef } from 'react';
import UtilityService from '../../../services/UtilityService';

type HtmlLabelProps = {
  children: string;
  testId: string;
  className?: string;
};

const HtmlLabel: React.FC<HtmlLabelProps> = ({
  children,
  testId,
  className = '',
}: HtmlLabelProps) => {
  const divRef = useRef<HTMLDivElement>(null);
  const classes = `${className}`;

  useEffect(() => {
    if (divRef.current) {
      divRef.current.innerHTML = UtilityService.sanitizeHtml(children);
    }
  }, [children]);

  return <div ref={divRef} className={classes} data-testid={testId} />;
};

export default HtmlLabel;
